import React from 'react'

import { Autocomplete, Box, TextField, createFilterOptions } from '@mui/material'

import { FormFieldOption } from '../Form/Form.types'
import styles from './Dropdown.styles'
import { DropdownProps } from './Dropdown.types'

// Create a custom filter that searches anywhere in the label (case-insensitive)
const filterOptions = createFilterOptions<FormFieldOption>({
  matchFrom: 'any',
  stringify: (option) => option.label
})

const Dropdown: React.FC<DropdownProps> = ({
  options,
  setValue,
  name,
  label,
  isEditable,
  value,
  disabled,
  readOnly,
  marginTop,
  loading,
  loadingText = 'Loading...'
}) => {
  return (
    <Box sx={styles.container(marginTop)}>
      <Autocomplete
        options={options || []}
        loading={loading}
        loadingText={loadingText}
        getOptionLabel={(option: FormFieldOption) => option.label}
        filterOptions={filterOptions}
        renderInput={(params: object) => (
          <TextField {...params} name={name} label={label} fullWidth sx={styles.textField(isEditable)} />
        )}
        readOnly={readOnly}
        value={options?.find((option: FormFieldOption) => option.value === value) || null}
        onChange={(_event: unknown, newValue: FormFieldOption | null) => {
          setValue(newValue ? newValue.value.toString() : '')
        }}
        disabled={disabled}
      />
    </Box>
  )
}

export default Dropdown
